import React from 'react'
import PropTypes from 'prop-types'
import ToggleButton from './ToggleButton'

const ToggleGroup = ({ ariaLabel, options, value, onChange }) => (
  <div aria-label={ariaLabel} role="group" className="tw:inline-flex">
    {options.map((option, index) => (
      <ToggleButton
        key={option.value}
        isActive={option.value === value}
        isFirst={index === 0}
        isLast={index === options.length - 1}
        label={option.label}
        value={option.value}
        onSelect={onChange}
      />
    ))}
  </div>
)

ToggleGroup.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ToggleGroup
